
export enum PickupRequesterRoleCd {
	CONSIGNEE = 'Consignee',
	SHIPPER = 'Shipper',
	THIRD_PARTY = 'ThirdParty',
	UNDEFINED = 'Undefined'}
